import React, {useEffect, useState} from 'react';
import TakisHero from "../components/TakisHero"
import useCategoryData from '../hooks/useCategoryData';
import TakisGrid from '../components/TakisGrid';
import TakisFreeText from '../components/TakisFreeText';
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton";
import TakisFreeTextSkeleton from "../components/Skeletons/TakisFreeTextSkeleton";
import TakisGridSkeleton from "../components/Skeletons/TakisGridSkeleton";

const Category = ({pagePath}) => {
  const [categoryData, setCategoryData] = useState('');

  const { error, isLoading, categoryQueryData } = useCategoryData(pagePath);


  useEffect(() => {
    if (categoryQueryData) {
      setCategoryData(categoryQueryData);
    }
  }, [categoryQueryData]);

  if (isLoading || error || !categoryData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisFreeTextSkeleton/>
        <TakisGridSkeleton/>
      </>
    );
  }

  // Verificar si es la sección de multipacks
  const isMultipacksSection =
    pagePath?.toLowerCase().includes('multipack') ||
    categoryData?.gridCategory?.title?.toLowerCase().includes('multipack');

  return (
    <>
      <TakisHero
        data={categoryData.hero}
      />
      <TakisFreeText
        title={categoryData.freeText.title}
        isSectionTitle={true}
        paragraphsFirstColumn={categoryData.freeText.paragraphsFirstColumn}
        paragraphsSecondColumn={categoryData.freeText.paragraphsSecondColumn}
        ctas={categoryData.freeText.ctas}
      />
      <TakisGrid
        title={categoryData.gridCategory.title}
        items={categoryData.gridCategory.items}
        disableLinks={isMultipacksSection}
      />
    </>
  );
};

export default Category;
